/**
 * Table column configuration for the reports list
 */
export const TABLE_COLUMNS = [
    {
        field: 'title',
        headerName: 'Product name',
        editable: true,
        flex: 1
    },
    {
        field: 'userDisplayName',
        headerName: 'Author',
        editable: true,
        flex: 1
    },
    {
        field: 'productType.label',
        headerName: 'Product Type',
        editable: true,
        flex: 1
    },
    {
        field: 'updatedAt',
        headerName: 'Last Updated',
        editable: true,
        flex: 1
    },
    {
        field: 'status',
        headerName: 'Status',
        editable: true,
        flex: 1
    },
];

export const REPORT_STATUS = {
    AWAITING_REVIEW: 'Awaiting Review',
    APPROVED: 'approved',
};
